import storage from "store";
import { AllState } from "../index";
import { ActionContext } from "vuex";
import { LoginForm, CodeLoginForm } from "@/types/views/login";
import { RouterTable, IamRouterTable } from "@/types/api/login";
import { generator } from "@/utils/parsingRouter";
import {
  login,
  codeLogin,
  info,
  menu,
  getLoginHarbour,
  apiGetHarbourUserInfo,
} from "@/api/login";
import { serializRouter, labelForChildApp } from "@/utils/parsingRouter";
import {
  handleOriginMenus,
  handlePageListInfo,
  transformDataToResult,
  getAllBtnAndAttrAuth,
} from "@/handles/router";
import { HARBOUR_PORTAL_PC } from "@/constant";
import store from "@/store";
import router from "@/router";
import { clearStorage } from "@/utils/common";
// 处理用户登录、登出、个人信息、权限路由

export type UserState = {
  token: string;
  nick: string;
  routers?: RouterTable;
  contactPhone?: string;
  headImageUrl?: string | null;
  huid?: string;
  identityId?: number;
  identityToken?: string | null;
  memberNo?: string;
  memberTag?: string | null;
  orgRootId?: number;
  personal?: boolean;
  uid?: number;
  pageListInfo: any;
  isShowMenu: boolean;
  showMenuHide: boolean;
  workbenchPageInfo: any;
  harbourUserInfo: any;
};

const state: UserState = {
  // 标识
  token: storage.get("token"),
  // 昵称
  nick: "",
  // 头像
  headImageUrl: "",
  // 路由表(原始未解析)
  routers: [],

  pageListInfo: {},
  isShowMenu: storage.get("index_nav_hide_switch"),
  showMenuHide: false,
  workbenchPageInfo: {},
  harbourUserInfo: {},
};

const user = {
  namespaced: true,

  state,
  getters: {
    getPageListInfo(state: UserState) {
      if (state.pageListInfo && Object.keys(state.pageListInfo).length) {
        return state.pageListInfo;
      } else {
        const listInfo = JSON.parse(
          localStorage.getItem("pageListInfo") || "{}"
        );
        if (listInfo && Object.keys(listInfo).length) {
          return listInfo;
        }
        return {};
      }
    },
  },

  mutations: {
    // 设置token
    setToken(state: UserState, token: string) {
      state.token = token;
    },
    setHarbourUserInfo(state: UserState, user: any) {
      state.harbourUserInfo = user;
    },

    // 设置用户信息
    setInfo(state: UserState, info: UserState) {
      const { nick, headImageUrl } = info;
      state.nick = nick;
      state.headImageUrl = headImageUrl;
    },

    // 设置路由表(原始未解析)
    setRouters(state: UserState, routers: RouterTable) {
      state.routers = routers;
    },

    // 用户退出登录
    clearState(state: UserState) {
      clearStorage();
      sessionStorage.clear();
      // storage.clearAll();
      state.nick = "";
    },

    // 设置路由表(原始未解析)
    setPageListInfo(state: UserState, pageListInfo: any) {
      state.pageListInfo = pageListInfo;
    },
  },

  actions: {
    // 登录
    login(context: ActionContext<UserState, AllState>, params: LoginForm) {
      return new Promise((resolve, reject) => {
        login(params)
          .then(async (e) => {
            const data = e.data.data;
            // storage.set('token')存储的字符串包含首尾双引号，子应用取token发请求会401
            localStorage.setItem("token", data.token);
            localStorage.setItem("iam-token", data.token);
            context.commit("setToken", data.token);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    // 验证码登录
    captchaLogin(
      context: ActionContext<UserState, AllState>,
      params: LoginForm
    ) {
      return new Promise((resolve, reject) => {
        login(params)
          .then(async (e) => {
            const data = e.data.data;
            // storage.set('token')存储的字符串包含首尾双引号，子应用取token发请求会401
            localStorage.setItem("token", data.token);
            localStorage.setItem("iam-token", data.token);
            context.commit("setToken", data.token);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    // 二维码登录
    codeLogin(
      context: ActionContext<UserState, AllState>,
      params: CodeLoginForm
    ) {
      return new Promise((resolve, reject) => {
        codeLogin(params)
          .then((e) => {
            const data = e.data.data;
            // storage.set('token')存储的字符串包含首尾双引号，子应用取token发请求会401
            localStorage.setItem("token", data.token);
            localStorage.setItem("iam-token", data.token);
            context.commit("setToken", data.token);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    // 获取用户信息
    userInfo(context: ActionContext<UserState, AllState>) {
      return new Promise(async (resolve) => {
        let userInfo = storage.get("userInfo");
        if (!userInfo) {
          const { data } = await info();
          userInfo = data.data;
          storage.set("userInfo", userInfo);
          localStorage.setItem("webphone", JSON.stringify(userInfo));
          localStorage.setItem("iam-user-info", JSON.stringify(userInfo));
          localStorage.setItem("loginMethod", "iam-login");

          // 获取顺风车token
          const { data: rideData } = await getLoginHarbour({
            companyId: 44760,
            name: userInfo.nick,
            userId: userInfo.huid,
          });

          localStorage.setItem("free-ride-token", rideData.data);
          // const result = await menu({ portalCode: "F2EHB" });
          // if (result.data.success) {
          //   //f2E项目需要根据queryKeys判断是否有页面访问权限所以，提前注入
          //   const { queryKeys: f2eQueryKeys } = handleOriginMenus(
          //     result.data.data
          //   );
          //   localStorage.setItem(
          //     "permissionList",
          //     JSON.stringify(f2eQueryKeys)
          //   );
          // }
          try {
            const result = await apiGetHarbourUserInfo();
            if (result.data.success) {
              // context.commit('setHarbourUserInfo',result.data.user)
              localStorage.setItem(
                "harbourUserInfo",
                JSON.stringify(result.data.user)
              );
              try {
                window.localStorage.setItem(
                  "webphone",
                  JSON.stringify(result.data.user)
                );
              } catch (e: any) {
                if (e.name == "QuotaExceededError") {
                  // localStorage.clear();
                  localStorage.removeItem("webphone");
                  window.localStorage.setItem(
                    "webphone",
                    JSON.stringify(result.data.user)
                  );
                }
              }
            }
            console.log(result, "resultresult");
          } catch (error) {}
        }
        context.commit("setInfo", userInfo);
        resolve(userInfo);
      });
    },

    // 获取菜单
    menu(context: ActionContext<UserState, AllState>) {
      return new Promise(async (resolve) => {
        let menuList = storage.get(
          `${import.meta.env.VITE_PORTAL_CODE}_menuList`
        );
        const response = await menu({
          portalCode: import.meta.env.VITE_PORTAL_CODE,
        });
        // console.log(,'<==================================================')
        if (response.data && response.data.data) {
          const allBtnAndAttrAuth = getAllBtnAndAttrAuth(response.data.data);
          // sessionStorage 注入全局权限
          sessionStorage.setItem(
            "globalAuth",
            JSON.stringify(allBtnAndAttrAuth)
          );
          const Workbench =
            response.data.data.find(
              (v: any) => v.funcType === "TAB" && v.path === "/control-center"
            ) || null;
          // 将 Workbench 挂载到 store.Workbench
          context.state.workbenchPageInfo = Workbench;
          console.log(response.data.data, "response.data.data");
          // console.log(allBtnAndAttrAuth, "allBtnAndAttrAuth");
          const result = transformDataToResult(response.data.data);
          if (result && Object.keys(result).length) {
            for (const key in result) {
              if (result[key] && result[key].length) {
                const list = serializRouter(
                  [],
                  [
                    labelForChildApp(
                      result[key],
                      key
                    ) as unknown as IamRouterTable[],
                  ]
                );
                storage.set(`${key}_menuList`, list);
                if (key === 'F2E-harbour-web') {
                  const keys = [];
                  let pathList: any = [];
                  if (list[0] && list[0]?.children) {
                    pathList = list[0]?.children
                  }
                  for (const item of pathList) {
                    if (item.permissions && item.permissions.length) {
                      keys.push(...item.permissions)
                    }
                  }
                  localStorage.setItem(
                    "permissionList",
                    JSON.stringify(keys)
                  );
                }
              }
            }
          }
          menuList = serializRouter(
            [],
            [
              labelForChildApp(
                [...response.data.data],
                HARBOUR_PORTAL_PC
              ) as unknown as IamRouterTable[],
            ]
          );
          // console.log(menuList.splice(0,2), "menuList");
          // 缓存菜单数据
          storage.set(`${import.meta.env.VITE_PORTAL_CODE}_menuList`, menuList);
          context.commit("setRouters", menuList);

          // 处理页面列表信息
          const pageListInfo = handlePageListInfo(menuList, {}, true);
          localStorage.setItem("pageListInfo", JSON.stringify(pageListInfo));
          context.commit("setPageListInfo", pageListInfo);
          // 初始化侧边菜单
          if (menuList && menuList.length > 0) {
            const origin = menuList[0]["children"] || [];
            context.rootState.menu.menuRouter = origin;
            context.rootState.menu.menuId = menuList[0]["id"];
          } else {
            context.rootState.menu.menuRouter = [];
            context.rootState.menu.menuId = null;
          }
          resolve(generator(menuList));
        } else {
          // eslint-disable-next-line no-console
          console.error("菜单数据获取失败");
          resolve([]);
        }
      });
    },

    // 退出登录
    logout(context: ActionContext<UserState, AllState>) {
      return new Promise<void>((resolve) => {
        router.push("/login");
        context.commit("clearState");
        store.commit("tabs/clearList");
        store.commit("globalState/clearAllApps");
        resolve();
      });
    },
  },
};

export default user;
